import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GrClose } from "react-icons/gr";
import "./catSearch.css";
import { elakayAutoText } from "../../pageInside/dataElakay";
import useDebouncedValue from "../../pageInside/hooks/useDebouncedValue";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["catSearch"]?.[key] || fallback;

const CatSearch = (props) => {
    const {
        infoSource,
        getCategoriesByName,
        categoyseleted = [],
        categories = [],
        search,
        setSearch,
        searchInput,
        setSearchInput,
        loadCategory,
        // Optionnel : rapporte l'état de la recherche au parent (searching
        // pendant l'appel, puis results/error une fois résolue) -- utilisé
        // par le wizard de sync CJ pour afficher un badge Found/Not found,
        // sans dupliquer cette logique de fetch. N'affecte aucun appelant
        // existant qui ne le passe pas (addProduct.jsx, editProduct.jsx).
        onSearchStateChange
    } = props;
  __setElakayInfoSource(infoSource);

    const [error, setError] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    let limit = 10;
    let skip = 0;

    const calculateFontSize = (index, totalElements) => {
        const maxSize = 18;
        const minSize = 12;
        const sizeStep = (maxSize - minSize) / (totalElements - 1);
        return maxSize - (index * sizeStep);
    };

    const CategorieName = (a, l) => {
        return (
            <p>
                {Array.isArray(a) && a.slice(0, -1)?.map((word, index) => (
                    <span
                        key={index}
                        style={{ fontSize: `${calculateFontSize(index, l)}px` }}
                    >
                        {word}{index < l - 1 ? ' / ' : ''}
                    </span>
                ))}
            </p>
        );
    };

    const searchData = (search) => {
        if (search) {
            setIsSearching(true);
            onSearchStateChange && onSearchStateChange({ searching: true });
            getCategoriesByName(skip, limit, search).then(
                response => {
                    setIsSearching(false);
                    if (response.error) {
                        setError(response.error);
                        onSearchStateChange && onSearchStateChange({ searching: false, error: response.error });
                    } else {
                        setSearch(response);
                        setError("");
                        onSearchStateChange && onSearchStateChange({ searching: false, results: response });
                    }
                }
            ).catch(err => {
                setIsSearching(false);
                const message = elakayAutoText("h_26fb2751ee2474", "Failed to search categories");
                setError(message);
                onSearchStateChange && onSearchStateChange({ searching: false, error: message });
            });
        }
    };

    const loadingCategoyName = (search) => {
        if (isSearching) {
            return (
                <div className="loadind_catSearch loading-state">
                    <h5 style={{ textAlign: 'center', color: '#64748b' }}>{__elakayText("t001", "Searching...")}</h5>
                </div>
            );
        }

        if (!search || search.length === 0) {
            return (
                <div
                    className="loadind_catSearch empty"
                    data-empty-label={
                        searchInput
                            ? elakayAutoText("h_31994b16cf2872", "No categories found")
                            : elakayAutoText("h_0f015405b4070f", "Start typing to search categories")
                    }
                />
            );
        }

        return (
            <div className="loadind_catSearch">
                {search && search?.map((cat, i) => (
                    <h5
                        key={i}
                        onClick={() => {
                            loadCategory(cat._id);
                            setSearchInput('');
                            setSearch([]);
                        }}
                        role="button"
                        tabIndex={0}
                        aria-label={elakayAutoText("h_45626dff9b108f", "Select {value0} category", { value0: infoSource.getCategoryNames(cat, true).name.slice(0, -1).join(', ') })}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                loadCategory(cat._id);
                                setSearchInput('');
                                setSearch([]);
                            }
                        }}
                    >
                        <span className="m-1" style={{ fontSize: '14px' }}>
                            {infoSource.getCategoryNames(cat, true).name.slice(0, -1).join(', ')}
                        </span>
                    </h5>
                ))}
                {showError()}
            </div>
        );
    };

    const showError = () => (
        <div
            className="alert alert-danger"
            style={{ display: error ? "" : "none" }}
            role="alert"
        >
            {error}
        </div>
    );

    // Debounced: searchData() used to fire on every keystroke. Now it only
    // fires ~300ms after the user stops typing (same pattern as the header
    // search box, see includes/pageInside/search.js).
    const debouncedSearchInput = useDebouncedValue(searchInput, 300);
    useEffect(() => {
        if (debouncedSearchInput) searchData(debouncedSearchInput);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchInput]);

    const handleChange = name => event => {
        let val = event.target.value;
        setError(false);
        setSearchInput(event.target.value);

        if (val?.length === 0) {
            setSearch([]);
            setIsSearching(false);
        }
    };

    const searchForm = () => (
        <form className="mb-0">
            <div className="text-center" id="heading">
                {CategorieName(
                    categories && categories.name,
                    categories && categories.name && categories.name?.length
                )}
            </div>

            {/* Search Input Premium */}
            <div className={`catSearchInp ${isSearching ? 'loading' : ''}`}>
                <input
                    id="txtSearch"
                    onChange={handleChange("search")}
                    type="search"
                    placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).categoryCatSearch.t001}
                    value={searchInput}
                    name="ref"
                    aria-label={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).categoryCatSearch.t002}
                    autoComplete="off"
                />
            </div>

            {/* Results List */}
            {loadingCategoyName(search)}
        </form>
    );

    return searchForm();
};

export default CatSearch;
